module.exports = __webpack_public_path__ + "static/media/5_square.b212a60e.png";